import { setupI18n } from '@lingui/core';
import { I18nProvider } from '@lingui/react';
import { createFileRoute } from '@tanstack/react-router';
import { useState } from 'react';
import { z } from 'zod';

import { messages as enMessages } from '#features/i18n/locales/en/messages.po';
import { messages as ruMessages } from '#features/i18n/locales/ru/messages.po';
import { LandingV2 } from '#features/landing/components/LandingV2';
import { messageOverrides } from '#features/landing/components/LandingV2/messageOverrides';
import { landingRouteLoader } from '#features/landing/utils/landingRoute';

export const Route = createFileRoute('/{-$locale}/_layout/preview/landing_v2')({
  staticData: { rendersOwnHeader: true, rendersOwnFooter: true },
  component: LandingV2Preview,
  loader: ({ context }) => landingRouteLoader(context.queryClient, 'index'),
  validateSearch: z.object({ lang: z.enum(['ru', 'en']).default('ru') }),
  ssr: false,
  head: () => ({ meta: [{ name: 'robots', content: 'noindex, nofollow' }] }),
});

function LandingV2Preview() {
  const { lang } = Route.useSearch();
  return <LocalizedPreview key={lang} lang={lang} />;
}

function LocalizedPreview({ lang }: { lang: 'ru' | 'en' }) {
  const [i18n] = useState(() =>
    setupI18n({
      locale: lang,
      messages: Object.fromEntries(
        Object.entries({ en: enMessages, ru: ruMessages }).map(([locale, catalog]) => [
          locale,
          {
            ...catalog,
            ...Object.fromEntries(
              messageOverrides.map(([original, updated]) => [
                original.id ?? '',
                catalog[updated.id ?? ''],
              ])
            ),
          },
        ])
      ),
    })
  );
  return (
    <I18nProvider i18n={i18n}>
      <LandingV2 gameSlug="index" />
    </I18nProvider>
  );
}
